// src/pages/PaymentFailurePage.tsx
// Página de erro quando pagamento falha

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, HelpCircle } from 'lucide-react';
import './PaymentResultPage.css';

const PaymentFailurePage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="payment-result-page failure">
            <div className="result-container">
                <div className="result-icon failure-icon">
                    <XCircle size={80} strokeWidth={1.5} />
                </div>

                <h1>Pagamento Não Aprovado</h1>
                <p className="result-message">
                    Infelizmente não foi possível processar seu pagamento.
                    Verifique os dados e tente novamente.
                </p>

                <div className="result-actions">
                    <button
                        className="btn-primary"
                        onClick={() => navigate(-1)}
                    >
                        <ArrowLeft size={20} />
                        Tentar Novamente
                    </button>

                    <button
                        className="btn-secondary"
                        onClick={() => navigate('/marketplace')}
                    >
                        Voltar ao Marketplace
                    </button>
                </div>

                <div className="failure-info">
                    <div className="info-box">
                        <h3>
                            <HelpCircle size={20} />
                            Possíveis causas
                        </h3>
                        <ul>
                            <li>Saldo insuficiente</li>
                            <li>Dados do cartão incorretos</li>
                            <li>Limite de crédito atingido</li>
                            <li>Problema temporário com a operadora</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailurePage;